import { scope } from '@otto-ec/global-resources/debug';

export const clientLoggerScope = scope('ft9bcn.teaserui');